import MaskedTextField from "../../MaskedTextField";
import TextArea from "../../TextArea";
import TextField from "../../TextField";
import { unFormatCnpj as unFormatMask } from "@/common/utils/unFormatters";

interface AddressFormFieldsDefaultProps {
  value: string;
  error?: string;
  onChange?: (newValue: string) => void;
  disabled?: boolean;
  markAsRequired?: boolean;
}

interface ZipcodeTextFieldProps extends AddressFormFieldsDefaultProps {
  isPending?: boolean;
}

export const ZipcodeTextField = ({
  value,
  error,
  onChange,
  disabled,
  markAsRequired,
  isPending,
}: ZipcodeTextFieldProps) => {
  return (
    <MaskedTextField
      name="zipcode"
      mask="00000-000"
      label="CEP"
      value={value || ''}
      errorMessage={error || undefined}
      onChange={(e) => onChange?.(unFormatMask((e.target as HTMLInputElement).value))}
      disabled={disabled}
      RightIcon={isPending ? <div className="w-4 h-4 border-4 border-dashed rounded-full animate-spin border-blue-800 mb-1 mr-1" /> : <></>}
      markAsRequired={markAsRequired}
    />
  );
};

export const StreetTextField = ({
  value,
  error,
  onChange,
  disabled,
  markAsRequired,
}: AddressFormFieldsDefaultProps) => {
  return (
    <TextField
      name="street"
      label="Logradouro"
      className="w-3/4"
      value={value}
      onChange={(e) => onChange?.((e.target as HTMLInputElement).value)}
      errorMessage={error || undefined}
      disabled={disabled}
      markAsRequired={markAsRequired}
    />
  );
};

export const NumberTextField = ({
  value,
  error,
  onChange,
  disabled,
  markAsRequired,
}: AddressFormFieldsDefaultProps) => {
  return (
    <TextField
      name="number"
      label="Número"
      value={value}
      className="w-1/4"
      onChange={(e) => onChange?.((e.target as HTMLInputElement).value)}
      errorMessage={error || undefined}
      disabled={disabled}
      markAsRequired={markAsRequired}
    />
  );
};

export const CityTextField = ({
  value,
  error,
  markAsRequired,
}: AddressFormFieldsDefaultProps) => {
  return (
    <TextField
      name="city"
      label="Município"
      value={value || ''}
      errorMessage={error || undefined}
      disabled
      markAsRequired={markAsRequired}
    />
  );
};

export const NeighborhoodTextField = ({
  value,
  error,
  onChange,
  disabled,
  markAsRequired,
}: AddressFormFieldsDefaultProps) => {
  return (
    <TextField
      name="neighborhood"
      label="Bairro"
      maxLength={64}
      value={value}
      errorMessage={error || undefined}
      onChange={(e) => onChange?.((e.target as HTMLInputElement).value)}
      disabled={disabled}
      markAsRequired={markAsRequired}
    />
  );
};

export const StateTextField = ({
  value,
  markAsRequired,
}: AddressFormFieldsDefaultProps) => {
  return (
    <TextField
      name="state"
      label="Estado"
      value={value}
      disabled
      markAsRequired={markAsRequired}
    />
  );
};

export const ComplementTextField = ({
  value,
  onChange,
  disabled,
}: AddressFormFieldsDefaultProps) => {
  return (
    <TextArea
      name="complement"
      label="Complemento"
      rows={3}
      value={value || ''}
      onChange={(e) => onChange?.((e.target as HTMLInputElement).value)}
      disabled={disabled}
    />
  );
};
